module.exports = "https://web-assets.ifttt.com/packs/media/shared/applet-card-public-icon-5ae85cf0.svg";